<template>
  <div class="bg-dim flex-col">
    <div class="safe-area absolute">
      <div class="popup-wrap">
        <div>
          <span>법인카드 등록 후,</span>
          <span>선물하기로 시상하세요.</span>
        </div>
      </div>
      <div @click="alertConfirm">
        <bottom-button  :buttonArray="buttonArray"></bottom-button>
      </div>
    </div>
  </div>
</template>
<script>
import BottomButton from "@/components/common/BottomButton.vue";

export default {
  name: "awardPopup",
  components: { BottomButton },
  data() {
    return {
      buttonArray: [
        //투버튼 일때
        // {
        //   className: "button-bg-gray border-left-round",
        //   text: "닫기",
        // },
        // {
        //   className: "button-bg-yellow border-right-round",
        //   text: "확인",
        // },
        //원버튼일떄
        {
          className: "button-bg-yellow border-round",
          text: "확인",
        },
      ],
    };
  },
  methods: {
    alertConfirm() {
      this.$router.push({ path: "/award/emarticonAwardHome" });
    }
  }
};
</script>
<style lang="scss" scoped>
@import "@/assets/styles/pages/award/awardPopup.scss";
</style>